<template>
  <div class="plv-ia-rpr-qrcode">
    <div v-if="!status || status === 'WAIT_PAY'" class="plv-ia-rpr-qrcode-content">
      <div class="plv-ia-rpr-qrcode-header">
        <h1>{{ t('plvIA.redpacketRain.putRedpacket') }}</h1>
        <i @click="$emit('on-close')">&times;</i>
      </div>
      <div class="plv-ia-rpr-qrcode-img">
        <img :src="url" />
        <p>{{ t('plvIA.redpacketRain.plessQrcode') }}</p>
        <!-- <p v-if="status === 'WAIT_PAY'"><i class="success-icon success-icon-small"></i> 扫描成功，请完成支付</p>
        <p v-else>请使用微信扫一扫二维码完成支付</p> -->
      </div>
    </div>
    <div v-else class="plv-ia-rpr-qrcode-result">
      <template v-if="status === 'SUCCESS'">
        <i class="success-icon"></i>
        <p>{{ t('plvIA.redpacketRain.plessQrcode') }}</p>
      </template>
      <template v-else>
        <i class="fail-icon"></i>
        <p>支付失败，请重试</p>
      </template>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  name: 'RedpacketQrcode',
  mixins: [Locale],
  props: {
    qrcodeUrl: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'WAIT_PAY'
    }
  },
  computed: {
    url() {
      return 'https://live.polyv.net/qrcode?url=' + this.qrcodeUrl;
    }
  }
};
</script>

<style lang="scss" scoped>
.success-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #0A8DFF;
  position: relative;
  &:before, &:after {
    content: '';
    position: absolute;
    background: #fff;
  }
  &:before {
    width: 15px;
    height: 4px;
    border-radius: 2px;
    top: 33px;
    left: 13px;
    transform: rotate(50deg);
  }
  &:after {
    width: 30px;
    height: 4px;
    border-radius: 2px;
    top: 29px;
    left: 20px;
    transform: rotate(140deg);
  }
}

.success-icon-small {
  width: 16px;
  height: 16px;
  &:before {
    width: 5px;
    height: 2px;
    border-radius: 2px;
    top: 8px;
    left: 3px;
  }
  &:after {
    width: 8px;
    height: 2px;
    border-radius: 2px;
    top: 7px;
    left: 5px;
  }
}

.fail-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #FB7272;
  position: relative;
  &:before, &:after {
    content: '';
    position: absolute;
    background: #fff;
  }
  &:before {
    width: 36px;
    height: 4px;
    border-radius: 2px;
    top: 28px;
    left: 12px;
    transform: rotate(40deg);
  }
  &:after {
    width: 36px;
    height: 4px;
    border-radius: 2px;
    top: 28px;
    right: 12px;
    transform: rotate(140deg);
  }
}
</style>

<style lang="scss">
.plv-ia-rpr-qrcode {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 6;
  &-content {
    position: absolute;
    z-index: 9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    padding-bottom: 18px;
  }
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid #ECEFF1;
    h1 {
      font-size: 14px;
      color: #333;
      font-weight: normal;
    }
    i {
      font-style: normal;
      font-size: 20px;
      color: #90A4AE;
      cursor: pointer;
    }
  }
  &-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 200px;
      height: 200px;
      margin: 24px 0;
    }
    p {
      font-size: 16px;
      display: flex;
      align-items: center;
    }
  }
  &-result {
    position: absolute;
    z-index: 9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 200px;
    height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      margin-top: 20px;
    }
  }
}
</style>
